import React, { useEffect, useState } from 'react'
import Header from '../header/Header';
import Footer from '../footer/Footer';
import { MdOutlineVideoLibrary } from "react-icons/md";
import img1 from '../../Assests_Url/image-teach.png'
import img2 from '../../Assests_Url/image-video.png'
import video1 from '../../Assests_Url/CONCEPT_AND_EXPLANATION_VIDEO.mp4'
import video2 from '../../Assests_Url/Interactive Exercises.mp4'
import video3 from '../../Assests_Url/Self_Assessments.mp4'
import video4 from '../../Assests_Url/AUDIO_ON_TOUCH.mp4'
import video5 from '../../Assests_Url/Personalisation.mp4'
import video6 from '../../Assests_Url/Dictionary_Translator.mp4'
import video7 from '../../Assests_Url/Multiple_ai.mp4'
import video8 from '../../Assests_Url/COVERAGE_REPORT.mp4'
import video9 from '../../Assests_Url/Multi_Search.mp4'

import { MdVideoLibrary } from "react-icons/md";
import { PiExamFill } from "react-icons/pi";
import { MdAssignment } from "react-icons/md";
import { RiVolumeUpFill } from "react-icons/ri";
import { FaLanguage } from "react-icons/fa6";
import pers from '../../Assests_Url/gridicons.png'
import aisearch from '../../Assests_Url/ai.png'
import coverage from '../../Assests_Url/cov-report.png'
import mul_search from '../../Assests_Url/multi-search.png'
import { useNavigate } from 'react-router-dom';
import { IoArrowUndoCircle } from 'react-icons/io5';


const ULearnFoundation = ({ RoutesClick, NcertClick }) => {
  const [registerModal, setRegisterModal] = useState(false);
  const [activeTabHeader, setActiveTabHeader] = React.useState("KATBOOK");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);

  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate()


  return (
    <div>
      <div>
        <Header
          activeTab={activeTabHeader}
          handleTabClick={handleTabClickHeader}
          studentregisterModal={studentregisterModal}
          setStudentRegisterModal={setStudentRegisterModal}
          ParentregisterModal={ParentregisterModal}
          setParentRegisterModal={setParentRegisterModal}
          TeacherregisterModal={TeacherregisterModal}
          setTeacherregisterModal={setTeacherregisterModal}
          registerModal={registerModal}
          setRegisterModal={setRegisterModal}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>

      <div className='container-uteach'>
        <div className='pt-5'>          
          <div className='d-flex align-items-center justify-content-between text-center pb-4'>
            <div>
              <IoArrowUndoCircle size={30} className='back-arrow'
                onClick={() => {
                  navigate("/katbook", { state: { scroll: "bottom" } });
                }}
              />
            </div>
            <div className='found-font'>
              ULearn Foundation Level
            </div>
            <div></div>
          </div>

          <div className='d-flex flex-column align-items-center gap-3'>
            <div className='meta-font'>
              The Power of Meta Content
            </div>
            <div className='text-foun-font text-center'>
              NCERT KATBOOKS are powered by state-of-the-art additional
              learning resources curated by Subject Matter Experts and top
              content creators from across the globe.
            </div>
            <div className='text-foun-font text-center'>
              Students can access these ready-to-use digital resources anytime
              and anywhere to understand concepts better and build clarity for
              complex topics.
            </div>
          </div>

          <div className='pt-5'>
            <div className='d-flex flex-column gap-5'>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    1. Embedded Videos (Concept & Explanation) <MdVideoLibrary size="25" />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Videos are embedded inside the KATBOOK itself to explain difficult
                    or important concepts. By tapping on the play button, students can
                    watch the video directly in the book window, without being
                    redirected to YouTube or any external platform. Longer videos
                    include timestamps for easy navigation.

                    <ul>
                      <li>
                        Acts as a ready-made visual learning aid for abstract or tough concepts.
                      </li>
                      <li>
                        Makes studying interactive and enjoyable.
                      </li>
                      <li>
                        Helps students save time by accessing the right explanation without
                        searching elsewhere.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video1} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    2. Interactive Exercise <PiExamFill size={"20px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    At the end of various sessions, interactive exercises are available in
                    the KATBOOK. Students can complete activities like draw and color,
                    drag-and-drop, or matching tasks.

                    <ul>
                      <li>
                        Encourages self-learning and exploration.
                      </li>
                      <li>
                        Makes study sessions fun and engaging.
                      </li>
                      <li>
                        Improves participation and concept recall.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video2} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    3. Assessments in KATBOOK <MdAssignment size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    KATBOOK includes a wide range of built-in assessments — such as
                    multiple choice, fill-in-the-blanks, and short or long answer
                    formats.

                    <ul>
                      <li>
                        Students can attempt quizzes for instant self-checks.
                      </li>
                      <li>
                        Helps students track their understanding in real time.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video3} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex flex-column align-items-center gap-3 pt-5'>
            <div className='meta-font'>
              INTERACTIVE FEATURES OF KATBOOK
            </div>
            <div className='text-foun-font text-center'>
              At U-Educate, we believe that education should go beyond textbooks — it
              should inspire curiosity, foster understanding, and support every
              learner’s unique journey. NCERT KATBOOKs transform traditional
              learning materials into a dynamic and interactive experience that
              empowers students to learn better.
            </div>
          </div>

          <div className='pt-5'>
            <div className='d-flex flex-column gap-5'>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    1. Audio Book Mode: ON <RiVolumeUpFill size={"20px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    With “audio on touch,” students can tap on any word, sentence or
                    image and the stories or poems come alive with audio.

                    <ul>
                      <li>
                        Helps students learn correct pronunciation.
                      </li>
                      <li>
                        Makes reading interactive and enjoyable.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video4} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    2. Personalisation <img src={pers} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Students can highlight important passages, add personal notes,
                    and bookmark lessons within the KATBOOK itself.

                    <ul>
                      <li>
                        Acts like a digital study diary.
                      </li>
                      <li>
                        Helps in revision and quick reference.
                      </li>
                      <li>
                        Supports better organization of learning.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video5} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    3. Inbuilt Dictionary & Translator <FaLanguage size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Students can highlight any word for instant meaning from the in-built
                    dictionary. They can also translate words, sentences, or the entire
                    book into the preferred regional language.

                    <ul>
                      <li>
                        Improves vocabulary and comprehension.
                      </li>
                      <li>
                        Enables independent learning without external help.
                      </li>
                      <li>
                        Supports bilingual and multilingual learning needs.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video6} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    4. AI Search <img src={aisearch} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    With AI Search, students can highlight any part of the book and ask
                    AI modules to generate summaries, Q&A, or other relevant information
                    for that section.

                    <ul>
                      <li>
                        Provides access to multiple resources in one place.
                      </li>
                      <li>
                        Strengthens understanding of lessons.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video7} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    5. Coverage Report <img src={coverage} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    When connected with KAMPUS during a school-wide rollout, students will
                    be able to see their personal progress — chapters covered, exercises
                    completed, and overall book progress.

                    <ul>
                      <li>
                        Helps track individual study progress.
                      </li>
                      <li>
                        Identifies areas that need improvement.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video8} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    6. Multiple Search <img src={mul_search} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Students can highlight and select any word or text from the
                    KATBOOK and use the Multiple Search feature to find information
                    across:

                    <ul>
                      <li>
                        Various AI tools like ChatGPT, Gemini, Perplexity
                      </li>
                      <li>
                        Web browsers
                      </li>
                      <li>
                        Encyclopedia's such as Wikipedia or Britannica
                      </li>
                      <li>
                        Dictionaries like Merriam-Webster or Oxford
                      </li>

                      This feature helps students explore beyond the textbook and build
                      deeper understanding.
                    </ul>

                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video9} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className='d-flex flex-column align-items-start gap-3 pt-5 pb-3'>
            <div className='meta-font'>
              STUDENT BENEFITS
            </div>
            <div className='cont-para'>
              <ul>
                <li>
                  Provides interactive resources to make learning engaging.
                </li>
                <li>
                  Encourages self-study and independent exploration.
                </li>
                <li>
                  Improves understanding, vocabulary, and critical thinking.
                </li>
                <li>
                  Helps track progress and stay organized.
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>


      <div>
        <Footer
          setActiveTab={setActiveTabHeader}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>
    </div>
  )
}

export default ULearnFoundation
